var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgTwitchLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1140 380",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 833,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170 170.01h-70V190h70v80.01H60l-40-40V20h80v70h70zM470 270.01H230l-40-40V90h80v100h20V90h80v100h20V90h80zM490 90h80v180h-80zM490 20h80v50h-80zM740 170.01h-70V190h70v80.01H630l-40-40V20h80v70h70zM920 170.01h-80V190h80v80.01H800l-40-40v-100L800 90h120zM1120 270.01h-80v-100h-20v100h-80V20h80v70h60l40 40.01z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1090 70h-50V0H930.21l-50.49 70H790l-30 30V70h-70V0H470v70H160.5L110 0H0v240l140 140h140v-40l40 40h270v-40l40 40h130v-40l40 40h250l90-90V120zM170 170h-70v20h70v80H60l-40-40V20h80v70h70zm300 100H230l-40-40V90h80v100h20V90h80v100h20V90h80zm100 0h-80V90h80zm0-200h-80V20h80zm170 100h-70v20h70v80H630l-40-40V20h80v70h70zm180 0h-80v20h80v80H800l-40-40V130l40-40h120zm200 100h-80V170h-20v100h-80V20h80v70h60l40 40z",
    fill: "#9146ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgTwitchLogo);
export default __webpack_public_path__ + "static/media/img-twitch-logo.bdedd8919c6a0b01fedcea397f86fe02.svg";
export { ForwardRef as ReactComponent };